import React, { Component } from 'react';
import { connect } from 'react-redux';

import Bar from "./Bar";
import BusinessTag from './BusinessTag';
import { addTags, editTags, deleteTags, errorTags } from '../redux/FeedbackRedux';

class FeedbackSettingsTags extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: ""
        };
    }

    handleAddTag() {
        this.props.dispatch(addTags());
        this.setState({ ...this.state, error: "" });
    }
    
    addFields(obj) {
        jQuery('body').find(".button_logic").find('input, textarea, select').each(function(index) {
            var identifier = jQuery(this).attr('name')+"_"+index;
            if(jQuery(this).attr('name') != '_token'){
                var value = jQuery(this).val();
                if(jQuery(this).attr('type') == "checkbox" || jQuery(this).attr('type') == "radio"){
                    if(jQuery(this).prop("checked") == true){
                        obj[identifier] = "checked";
                    } else {
                        obj[identifier] = "unchecked";
                    }
                } else {
                    obj[identifier] = value;
                }
            }
        });
        return obj;
    }

    doTheButtons(){
        window.after_changes = this.addFields({});
        if(JSON.stringify(window.before_changes) !== JSON.stringify(window.after_changes)){
            jQuery('.button_logic').find('button[type="submit"]').removeAttr('disabled');
        } else {
            jQuery('.button_logic').find('button[type="submit"]').attr('disabled', true);
        }
    }

    handleDeleteTag(uuid) {
        this.props.dispatch(deleteTags({ uuid: uuid }));
        this.setState({ ...this.state, error: "" }, () => {
            this.doTheButtons();
        });
    }

    handleChangeTag(uuid, event) {
        this.props.dispatch(editTags({ uuid: uuid, text: event.target.value, type: 'label' }));
        this.setState({ ...this.state, error: "" });
    }

    handleSave() {
        console.log("handle submit");
        var valid = true;
        var current_items = [];
        //do checks.. good stuff doesn't get prevent default
        this.props.state.business_tags.forEach((item, key) => {

            console.log("checking ");
            console.log(item);
            if (!item.label.trim()) {
                valid = false;
                console.log("Please Enter a Tag Label");
                this.props.dispatch(errorTags({ uuid: item.uuid, text: __("Please Enter a Tag Label") }));
                this.setState({ ...this.state, error: __("Please Enter a tag label.") });
            }
            else if (current_items.includes(item.label.trim())) {
                valid = false;
                this.props.dispatch(errorTags({ uuid: item.uuid, text: __("Please enter a non-duplicate Tag Label.") }));
                this.setState({ ...this.state, error: __("Please enter a non-duplicate tag label.") });
            } else {
                this.props.dispatch(errorTags({ uuid: item.uuid, text: false }));
                this.setState({ ...this.state, error: "" });
            }

            current_items.push(item.label.trim());

        });

        if (!valid) {
            event.preventDefault();
        }
    }

    render() {
        return (
            <form className="tags-form" method="post"
                onSubmit={this.handleSave.bind(this)}
                action={"/business/" + this.props.state.business.business_id + "/feedback-settings/tags/post"}>
                <input type="hidden" name="_token" className="makecsrf" />
                <input type="hidden" name="business_id" className="business_id" value={this.props.state.business.business_id} />
                <Bar middleCenter mobileColumn>
                    <p className='mb-0 w-100 mx-3'>{__('On this page you can add and edit tags for categorizing your Feedbacks. Tags allow you to quickly search for particular tag categories in your Feedback History. *A Feedback can be associated with multiple tags.')}</p>
                    <span className='text-primary mr-2 flex-shrink-0 save-change-alert ml-auto mt-1'>{__('Changes Made, Please Save The Changes')}</span>
                    <button className='btn btn-primary text-nowrap ml-auto mt-1' type='submit'>
                        <i className='fas fa-save mr-1' />
                        {__('Save Changes')}
                    </button>
                </Bar>

                <div className='p-2'>
                    <div className='card'>
                        <div className='title d-flex align-items-center px-3 py-2'>
                            <h4 className='mb-0'>Tags</h4>
                            <button className='btn btn-primary text-nowrap ml-5' onClick={this.handleAddTag.bind(this)} type="button">
                                <i className='fas fa-plus-circle mr-1' />{__('Add Tag')}
                            </button>
                        </div>
                        <div className='card-body'>
                            {
                                [...this.props.state.business_tags].sort((item1, item2) => {
                                    if (item1.id == null) return -1;
                                    if (item2.id == null) return 1;
                                    return item1.id - item2.id;
                                }).map((value, index) => {
                                    return <BusinessTag
                                        uuid={value.uuid}
                                        key={value.uuid} label={value.label}
                                        tag={value}
                                        delete={this.handleDeleteTag.bind(this, value.uuid)}
                                        update={this.handleChangeTag.bind(this, value.uuid)}
                                    />;
                                })
                            }
                            <p className='text-danger pl-2 pt-3'>{this.state.error}</p>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                    <button className='btn btn-primary text-nowrap' type='submit'>
                        <i className='fas fa-save mr-1' />
                        {__('Save Changes')}
                    </button>
                </div>
            </form>

        )
    }
}


function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(FeedbackSettingsTags);
